import { render, staticRenderFns } from "./SearchCandidates.vue?vue&type=template&id=891dea52&"
import script from "./SearchCandidates.vue?vue&type=script&lang=js&"
export * from "./SearchCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports